import Vue from "vue";
import VueI18n from "vue-i18n";
import { en } from "./langs/en.json";
import { uz } from "./langs/uz.json";
import { fr } from "./langs/fr.json";
import { ar } from "./langs/ar.json";

Vue.use(VueI18n);

export const selectedLocale = "uz";
export const languages = [
  { name: "O'zbek", value: "uz" },
  { name: "English", value: "en" },
  { name: "Frans", value: "fr" },
  { name: "Arab", value: "ar" },
];

const messages = {
  uz,
  en,
  fr,
  ar,
};

const i18n = new VueI18n({
  locale: selectedLocale,
  messages,
});

export default i18n;
